// Browser-tab titles for the dashboard: "No / SCAM - <Page>".
//
// Resolved from the pathname so every route gets one without each page
// having to remember. Order: explicit overrides, then the navigation tree
// (so a page added to navigation.js is covered automatically), then prefix
// matches for detail routes, then the legacy learn-more slugs.
//
// Pages that load their own title (a hot scam, an alert) call
// setDashboardTitle() once the data arrives to replace the section name.
import { DASHBOARD_NAV, pathBelongsTo } from './navigation';

const BRAND = 'No / SCAM';
// What index.html ships with, restored when the dashboard unmounts so the
// marketing site is not left with a dashboard title.
const BASE_TITLE = 'No / SCAM';

// Routes whose nav label is too terse on its own, or that are not in the nav.
const OVERRIDES = {
  '/dashboard/mosaic-psyops-explained': 'MoSAIC PSYOPS Explained',
  '/dashboard/cyberfraud-alert-explained': 'CyberFraud Alert Explained',
  '/dashboard/deepfake': 'Deepfake Detection',
  '/dashboard/image-check': 'Image Search',
  '/dashboard/av-library/fbi-ic3': 'FBI / IC3 Videos',
  '/dashboard/av-library/ssa': 'SSA Videos',
  '/dashboard/av-library/irs': 'IRS Videos',
  '/dashboard/av-library/ftc': 'FTC Videos',
  '/dashboard/av-library/podcast': 'Podcasts',
  '/dashboard/pig-butchering-crypto/results': 'Pig Butchering / Crypto Results',
  '/dashboard/catfishing-romance/results': 'Catfishing / Romance Results',
  '/dashboard/report': 'Report a Scam',
  '/dashboard/notifications': 'Notifications',
  '/dashboard/admin': 'Admin',
  '/dashboard/billing': 'Billing',
  '/dashboard/login': 'Sign in',
  '/dashboard/fraud-hq': 'Fraud HQ',
  '/dashboard/red-flag-pig-butchering-learn-more': 'Pig Butchering',
};

// Detail routes: section name until the page knows the item's own title.
const PREFIXES = [
  ['/dashboard/hot-scams/', 'ScamWire'],
  ['/dashboard/fraud-alerts/', 'CyberFraud Alert'],
];

const ACRONYMS = { atm: 'ATM', fbi: 'FBI', ic3: 'IC3', irs: 'IRS', ssa: 'SSA', ftc: 'FTC' };

const titleCase = (slug) =>
  slug
    .split('-')
    .filter(Boolean)
    .map((w) => ACRONYMS[w] || w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

function findInNav(pathname, entries) {
  for (const entry of entries) {
    if (entry.type === 'group') {
      const inner = findInNav(pathname, entry.items);
      if (inner) return inner;
      if (entry.path && pathBelongsTo(pathname, entry.path)) return entry.label;
    } else if (pathBelongsTo(pathname, entry.path)) {
      return entry.label;
    }
  }
  return null;
}

export function pageLabelForPath(pathname) {
  const p = (pathname || '').replace(/\/+$/, '') || '/';
  if (OVERRIDES[p]) return OVERRIDES[p];
  const fromNav = findInNav(p, DASHBOARD_NAV);
  if (fromNav) return fromNav;
  const prefix = PREFIXES.find(([pre]) => p.startsWith(pre));
  if (prefix) return prefix[1];
  const learnMore = /^\/dashboard\/(.+)-learn-more$/.exec(p);
  if (learnMore) return titleCase(learnMore[1]);
  return 'Dashboard';
}

export const formatDashboardTitle = (label) => (label ? `${BRAND} - ${label}` : BRAND);

export function setDashboardTitle(label) {
  document.title = formatDashboardTitle(label);
}

export function restoreBaseTitle() {
  document.title = BASE_TITLE;
}
